import { LegalPerson, NaturalPerson } from 'api';
import React, { FunctionComponent } from 'react';
import EditTaxInformationModal from './edit-tax-information-modal';
import EditBankAccountModal from './edit-bank-account-modal';

export interface InvestorEditModalsProps {
  id: string;
  isEditTaxInformationOpen: boolean;
  isEditBankAccountOpen: boolean;
  setEditTaxInformationModal: (val: boolean) => void;
  setEditBankAccountModal: (val: boolean) => void;
  fetchInvestorDetails: () => void;
  rootPerson: NaturalPerson | LegalPerson;
}

const InvestorEditModals: FunctionComponent<InvestorEditModalsProps> = (props) => {
  const {
    id,
    isEditTaxInformationOpen,
    setEditTaxInformationModal,
    isEditBankAccountOpen,
    setEditBankAccountModal,
    rootPerson,
    fetchInvestorDetails,
  } = props;

  return (
    <>
      {isEditTaxInformationOpen && (
        <EditTaxInformationModal
          onHideEditTaxInformation={() => setEditTaxInformationModal(false)}
          fetchInvestorDetails={fetchInvestorDetails}
          values={{
            id,
            isSubjectToGermanTax: rootPerson?.taxInformation?.isSubjectToGermanTax,
            taxIdentificationNumber: rootPerson?.taxInformation?.taxIdentificationNumber || '',
            nonAssessmentCertificate: rootPerson?.taxInformation?.nonAssessmentCertificate || false,
            nonAssessmentCertificateDoc: rootPerson?.taxInformation?.nonAssessmentCertificateDoc,
          }}
        />
      )}
      {isEditBankAccountOpen && (
        <EditBankAccountModal
          onHideEditBankAccount={() => setEditBankAccountModal(false)}
          fetchInvestorDetails={fetchInvestorDetails}
          values={{
            id,
            accountHolder: rootPerson?.bankAccount?.accountHolder,
            iban: rootPerson?.bankAccount?.iban,
          }}
        />
      )}
    </>
  );
};

export default InvestorEditModals;
